import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSearch } from '../../hooks/use-search';
import { QueryTagCompanies, QueryTagKeywords, QueryTagLocation, QueryTagSalary, QueryTagSet } from './kind';

import * as S from './query-tags.styles';

const queryTagSetConfig = {
  JobFilterEmploymentType: { propertyName: 'employmentType', labelKey: 'SE_FILTER_JOBS_TYPE_LABEL' },
  JobFilterCareerLevel: { propertyName: 'careerLevel', labelKey: 'SE_FILTER_JOBS_LEVEL_LABEL' },
  JobFilterDiscipline: { propertyName: 'discipline', labelKey: 'SE_FILTER_JOBS_DISCIPLINE_LABEL' },
  JobFilterIndustry: { propertyName: 'industry', labelKey: 'SE_FILTER_JOBS_INDUSTRY_LABEL' },
  JobFilterBenefitEmployeePerk: { propertyName: 'benefitEmployeePerk', labelKey: 'JOBS_SEARCH_FILTER_EMPLOYEE_PERKS' },
  JobFilterBenefitWorkingCulture: {
    propertyName: 'benefitWorkingCulture',
    labelKey: 'JOBS_SEARCH_FILTER_WORKING_ATMOSPHERE',
  },
  JobFilterCountry: { propertyName: 'country', labelKey: 'SE_FILTER_JOBS_COUNTRY_LABEL' },
  JobFilterCity: { propertyName: 'city', labelKey: 'SE_FILTER_JOBS_CITY_LABEL' },
  JobFilterRemoteOption: { propertyName: 'remoteOption', labelKey: 'SE_FILTER_JOBS_REMOTE_LABEL' },
} as const;

export const QueryTags: React.FC = () => {
  const { data, previousData } = useSearch();

  // Most filters are only represented by an id in the url query. We need to get the translation from X1
  const anyData = data ?? previousData;
  const filterCollection = anyData?.jobSearchByQuery?.searchQuery?.body?.filterCollection;

  return (
    <S.Container>
      <QueryTagCompanies />
      <QueryTagKeywords />
      <QueryTagLocation />
      <QueryTagSalary />
      {filterCollection?.map((filter) => {
        if (filter?.__typename && queryTagSetConfig[filter.__typename] && 'entityId' in filter) {
          const { propertyName, labelKey } = queryTagSetConfig[filter.__typename];

          return (
            <QueryTagSet
              filter={filter}
              propertyName={propertyName}
              label={<FormattedMessage id={labelKey} />}
              key={filter.entityId}
            />
          );
        }
      })}
    </S.Container>
  );
};
